import styles from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function BlackoutProtection() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.BlackoutProtection');

    const list = [
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069285380/icon1.svg',
            text: t('icon1'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069286800/icon2.svg',
            text: t('icon2'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069285988/icon3.svg',
            text: t('icon3'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069287214/icon4.svg',
            text: t('icon4'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069287572/icon5.svg',
            text: t('icon5'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069287388/icon6.svg',
            text: t('icon6'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069286616/icon7.svg',
            text: t('icon7'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069286996/icon8.svg',
            text: t('icon8'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069286379/icon9.svg',
            text: t('icon9'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069286193/icon10.svg',
            text: t('icon10'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069285771/icon11.svg',
            text: t('icon11'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1769069285583/icon12.svg',
            text: t('icon12'),
        },
    ];

    return (
        <div className={`${styles.blackoutProtection}`}>
            <div className="solution-item">
                <div className="text-box">
                    <div className="sub-title">{t('label')}</div>
                    <h2 className="title">{t('title')}</h2>
                    <div className="desc">{t('desc')}</div>
                </div>
                <div className="container">
                    <div className="bg-img">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524923608/Blackout1-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524441536/Blackout1-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="right-box">
                        <div className="icon-box">
                            <div className="box-title">{t('icon_title')}</div>
                            <div className="icon-content">
                                {list.map((item) => (
                                    <div className="icon-item" key={item.icon}>
                                        <div className="icon-img">
                                            <NextImage src={item.icon} alt={item.icon} />
                                        </div>
                                        <div className="icon-text">{item.text}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="tips">{t('icon_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
